import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SettingsSessionsCatalogKey } from './settingsSessions.i18n.js';
import { SETTINGS_SESSIONS_CATALOG } from './settingsSessions.i18n.js';

export type SettingsSessionsMessageId = `settingsSessions:${SettingsSessionsCatalogKey}`;

const PREFIX_LENGTH = 'settingsSessions:'.length;

/** `t()` for the stop-gap `settingsSessions:` scope (see `settingsSessions.i18n.ts`). */
export function useSettingsSessionsT(): { t: (id: SettingsSessionsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SettingsSessionsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SettingsSessionsCatalogKey;
      const raw = SETTINGS_SESSIONS_CATALOG[locale][key] ?? SETTINGS_SESSIONS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
